import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDriver, IDriversInitialState, IDriversList } from '@types';

import { initialDrivers } from './initialState';

export const driversSlice = createSlice({
    name: 'drivers',
    initialState: initialDrivers(),
    reducers: {
        setDrivers(state: IDriversInitialState, action: PayloadAction<IDriversList>) {
            state.driversList = action.payload;
        },

        setDriver(state: IDriversInitialState, action: PayloadAction<IDriver | null>) {
            state.driver = action.payload;
        },
    },
});
